import { useMutation } from '@tanstack/react-query';
import { POST, POST_LOGIN_EMPLOYEE } from '../../../services';

export const useLoginEmployee = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_LOGIN_EMPLOYEE(), payload);
      return response;
    },
  });

  return {
    mutate,
    isPending,
  };
};
